import { useState } from 'react'

import { ListControls } from '@/components/ui/list-controls/ListControls'
import { exportToExcel } from '@/utils'

import { useMapContext } from './MapContext'
import { useStatusColumnsContext } from './StatusColumns'
import StatusColumnSelector from './StatusColumns/StatusColumnsSelector'

/** Limit to map, export and column picker for the asset list, at the start of the toolbar's second row. */
export const AssetListControls = () => {
  const context = useMapContext()
  const { statusColumns } = useStatusColumnsContext()
  const [showColumnSelector, setShowColumnSelector] = useState<boolean>(false)

  const handleExport = () => {
    const dataColumns = statusColumns
      .filter((c) => c.selected === 1)
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .reduce(
        (acc, { selectedColumnsDatabaseName, selectedColumnsDisplayName }) => {
          acc[selectedColumnsDatabaseName] = selectedColumnsDisplayName
          return acc
        },
        {} as Record<string, string>
      )

    const selectedColumnsMap = {
      name: 'Asset',
      ...dataColumns,
    }

    exportToExcel(selectedColumnsMap, context.filteredAssets as unknown as Record<string, unknown>[], 'Cooltrax_Assets')
  }

  return (
    <>
      <ListControls
        limitToMap={
          context.sidebarState.layoutMode !== 'table'
            ? {
                isOn: context.sidebarState.limitToMap,
                onToggle: () => context.setSidebarState((prev) => ({ ...prev, limitToMap: !prev.limitToMap })),
              }
            : undefined
        }
        onDownload={handleExport}
        onConfigure={() => setShowColumnSelector(true)}
        disabled={!context.filters.companyId}
      />
      {showColumnSelector && <StatusColumnSelector onClose={() => setShowColumnSelector(false)} />}
    </>
  )
}
